import { Trans } from '@lingui/macro';
import dayjs from 'dayjs';

import { UiCard } from '../../components/ui/ui-card/ui-card';

export const UserTimeZoneNotify = () => {
  const isAmTimezone = dayjs.tz.guess() === 'Asia/Yerevan';

  return isAmTimezone ? null : (
    <UiCard>
      <Trans>
        С 08.10.2023 на сайте будет отображаться{' '}
        <b>
          местное время{' '}
          <span style={{ whiteSpace: 'nowrap' }}>(г. Ереван, GMT+4)</span>
        </b>{' '}
        для отправления и прибытия поездов.
      </Trans>
      <br />
      <Trans>Расписание движения поездов не изменится.</Trans>
    </UiCard>
  );
};
